import React from "react";

import { siteLocationPrefix } from "../../constants";
import { Programs } from "../../models/programsConfig";
import { TestButton } from "./TestButton";
import * as styles from "./TestStyle.module.css";

export const TestAaaActions = () => (
  <div className={styles.aaaActionsWrapper}>
    <h3>Aaa Actions</h3>
    <TestButton
      type={Programs.Aaa}
      url={`${siteLocationPrefix}/test/setAccountType?type=aaa`}
      title="Change Account type to AAA"
    />
    <TestButton
      type={Programs.Aaa}
      url={`${siteLocationPrefix}/test/setAccountType?type=id`}
      title="Change Account type to ID"
    />
    <TestButton
      type={Programs.Aaa}
      url={`${siteLocationPrefix}/test/setAaaHubAccess?on=true`}
      title="Turn ON AAA hub access"
    />
    <TestButton
      type={Programs.Aaa}
      url={`${siteLocationPrefix}/test/setAaaHubAccess?on=false`}
      title="Turn OFF AAA hub access"
    />
    <TestButton
      type={Programs.Aaa}
      url={`${siteLocationPrefix}/test/setOnboardingUserIdToContact`}
      title="Set OnboardingUserId to Contact (must be overriding account first)"
    />
  </div>
);
